import PropTypes from 'prop-types'
import { useMultilingualService } from '../../../../service/multilingualService'
import USBModal from '../../../../components/modal-wrapper/index'
import '../../edit/removeBill/removeBillPopup'

/**
 * Returns Remove bill popup
 * @method
 * @param {Boolean} openModal - flag value to oprn popup
 * @param {Function} closePopup - callback function to close popup
 * @param {Function} callhelpline - handler to remove bill
 * @returns {HTMLElement} Returns remove bill popup
 */
const AccessDeniedPopUP = ({ openModal, closePopup, callhelpline }) => {
  const { ACCESS_DENIED_POPUP } = useMultilingualService('addBillSearch')
  return (
    <div>
      <USBModal
        wrapClassName="addBillConfirmPopup"
        contentClassName="billpay-modal"
        addClasses="small-modal"
        isOpen={openModal}
        modalTitle={ACCESS_DENIED_POPUP.ACCESS_TITLE}
        backdrop="static"
        handleModalClose={closePopup}
        wrapID="accessdenied-bill-modal"
        zIndex="1050"
        data-test="modal-component"
        footerButtonOptions={[
          {
            type: 'primary',
            text: ACCESS_DENIED_POPUP.ACCESS_PRIMARY,
            id: 'ready-paybtn-yes-save',
            clickEvent: callhelpline
          },
          {
            type: 'secondary',
            text: ACCESS_DENIED_POPUP.ACCESS_CANCEL,
            id: 'ready-closebtn',
            clickEvent: closePopup
          }
        ]}
      >
        <p style={{ fontWeight: 400, lineHeight: '24px', fontSize: '1rem' }}>
          {' '}
          {ACCESS_DENIED_POPUP.ACCESS_CONTENT}
        </p>
      </USBModal>
    </div>
  )
}

AccessDeniedPopUP.propTypes = {
  openModal: PropTypes.bool.isRequired,
  closePopup: PropTypes.func.isRequired,

  callhelpline: PropTypes.func.isRequired
  // intl: PropTypes.objectOf(PropTypes.any)
}

export default AccessDeniedPopUP
